module.exports = __webpack_public_path__ + "static/media/Download_center.30c66060.svg";